import { useEffect, useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { parseJwt } from "../utils/custom";
import axios from "axios";

const PrivateRoute = (props) => {
  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  const router = useLocation();
  const { children } = props;
  const [isCheckingRefresh, setIsCheckingRefresh] = useState(false);
  const isLoggedIn = localStorage.getItem("token") ? true : false;

  useEffect(() => {
    if (token) {
      const decodedJwt = parseJwt(token);
      const isExpired =
        !decodedJwt || !decodedJwt.exp || decodedJwt.exp * 1000 < Date.now();

      if (isExpired) {
        const refreshToken = localStorage.getItem("refresh_token");
        if (refreshToken && !isCheckingRefresh) {
          setIsCheckingRefresh(true);
          const baseURL = process.env.REACT_APP_API_URL;
          axios
            .post(`${baseURL}/auth/refresh`, { refresh_token: refreshToken })
            .then((res) => {
              if (res.data?.access_token) {
                localStorage.setItem("token", res.data.access_token);
                if (res.data?.refresh_token) {
                  localStorage.setItem(
                    "refresh_token",
                    res.data.refresh_token
                  );
                }
                setIsCheckingRefresh(false);
              } else {
                localStorage.clear();
                navigate("/");
              }
            })
            .catch(() => {
              localStorage.clear();
              setIsCheckingRefresh(false);
              navigate("/");
            });
          return;
        }
        if (!refreshToken) {
          localStorage.clear();
          navigate("/");
        }
      } else {
        if (router.pathname === "/session") {
          navigate("/session");
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, isCheckingRefresh]);

  return isLoggedIn ? <>{children}</> : <Navigate replace={true} to="/" />;
};

export default PrivateRoute;
